export function navigiereExtern(url: string): void {
  if (!url.startsWith('/') && !url.startsWith('http://') && !url.startsWith('https://')) {
    console.error('Ungültige externe URL:', url);
    return;
  }
  window.location.href = url;
}

export function oeffneExtern(url: string): void {
  if (!url.startsWith('/') && !url.startsWith('http://') && !url.startsWith('https://')) {
    console.error('Ungültige externe URL:', url);
    return;
  }
  window.open(url, '_blank');
}
